/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { BuilderUserContext, FilterNames, FilterRestService } from '@gh/builder-shared';
import {
  BuilderPermission,
  JobListFilterDto,
  JobOrderRestService,
  SystemRoleBit,
} from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { GridLayoutService } from '@gh/core-ui-grid';
import { SlicedDataSource } from '@gh/core-data';
import { JobListItem } from './job.model';

@Injectable()
export class JobOrderListBusinessService implements InitViewService {
  COLUMN_ENABLE_CONDITION = {
    originalBudget: (): boolean => this.getPermissionForPrices(),
    originalContractAmount: (): boolean => this.getPermissionForPricesExtended(),
    originalProfitMargin: (): boolean => this.getPermissionForPrices(),
    currentBudget: (): boolean => this.getPermissionForPrices(),
  };

  constructor(private jobOrderRest: JobOrderRestService,
              private userContext: BuilderUserContext,
              private filterService: FilterRestService,
              private gridLayoutService: GridLayoutService) {
  }

  initView(route: ActivatedRouteSnapshot): any {
    return {
      gridLayout: this.gridLayoutService.get('jobOrdersList', this.COLUMN_ENABLE_CONDITION),
      filter:  this.filterService.get(FilterNames.jobOrdersList),
    };
  }

  findAllAsDataSource(filter: JobListFilterDto): SlicedDataSource<JobListItem> {
    return this.jobOrderRest.findAllAsDataSource(filter);
  }
  getPermissionForPrices(): boolean {
    return this.userContext.hasSystemRole(SystemRoleBit.Corporate)
      || this.userContext.hasSystemRole(SystemRoleBit.Master)
      || this.userContext.hasPermission(BuilderPermission.Estimating.JobEstimate.EDIT)
      || this.userContext.hasPermission(BuilderPermission.Estimating.JobEstimate.VIEW)
      || this.userContext.hasPermission(BuilderPermission.JobAdmin.Financials.VIEW);
  }

  getPermissionForPricesExtended(): boolean {
    return this.getPermissionForPrices()
      || this.userContext.hasPermission(BuilderPermission.Accounting.Draws.VIEW)
      || this.userContext.hasPermission(BuilderPermission.Accounting.Draws.PRODUCE);
  }
}
